import { useFormik } from "formik";
import { ModalComponent } from "..";
import {
  useAssignCooperativeOfficialMutation,
  useRemoveCooperativeOfficialMutation,
} from "../../../redux/features/cooperative/cooperative.api";
import { SingleCooperativeOfficial } from "../../../redux/features/cooperative/cooperative.type";
import { SingleRole } from "../../../redux/features/settings/settings.type";
import { assignOfficialSchema } from "../../../validationSchema";
import { Checkbox } from "../../inputs/checkbox";
import { TextInput } from "../../inputs/textInput";

export const AssignOfficialModal = ({
  isModalOpen,
  onModalClose,
  successCallback = () => {},
  role,
  official,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  successCallback?: () => void;
  role: SingleRole;
  official?: SingleCooperativeOfficial;
}) => {
  const [assignOfficial, { isLoading: assigningOfficial }] =
    useAssignCooperativeOfficialMutation();
  const [removeOfficial, { isLoading: removingOfficial }] =
    useRemoveCooperativeOfficialMutation();

  const {
    values,
    errors,
    isValid,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      email: "",
      agreed: false,
    },
    enableReinitialize: true,
    validationSchema: assignOfficialSchema(official?.MemberEmail),
    onSubmit: async (data) => {
      if (!!official) {
        const removeResp = await removeOfficial({
          official: role.id,
        });

        if (removeResp.data?.success) {
          const resp = await assignOfficial([
            {
              email: data.email,
              official: role.id,
            },
          ]);

          if (resp.data?.success) {
            resetForm();
            onModalClose();
            successCallback();
          }
        }
      } else {
        const resp = await assignOfficial([
          {
            email: data.email,
            official: role.id,
          },
        ]);

        if (resp.data?.success) {
          resetForm();
          onModalClose();
          successCallback();
        }
      }
    },
  });
  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen}
        onModalClose={() => {
          resetForm();
          onModalClose();
        }}
        title={`${!!official ? "Reassign" : "Assign"} Official`}
        subTitle={
          <p className="">
            Kindly provide the email address of the official you’re about to{" "}
            {!!official ? "reassign to the role of" : "assign the role of"}{" "}
            <span className="font-primary text-pry-green-200 font-medium">
              {role.Name}
            </span>
            .
          </p>
        }
        childrenClassName=""
        modalClassName="!min-h-[480px]"
        hasButtons
        proceedButtonText={`${!!official ? "Reassign" : "Assign"} Official`}
        onProceedClick={handleSubmit}
        hasCancelButton={false}
        isLoading={assigningOfficial || removingOfficial}
        isProceedDisabled={assigningOfficial || removingOfficial || !isValid}
      >
        <div className="flex flex-col gap-4">
          <TextInput
            type="text"
            name="email"
            value={values.email}
            placeholder="Enter email address"
            onChange={handleChange}
            onBlur={handleBlur}
            hasIcon={false}
            iconSvg={undefined}
            errors={errors?.email && touched?.email ? errors?.email : ""}
            hasTitle={false}
            autoComplete="off"
          />

          {!!official && (
            <Checkbox
              checked={values.agreed}
              onCheck={() => {
                setFieldValue("agreed", true);
              }}
              onUnCheck={() => {
                setFieldValue("agreed", false);
              }}
              text={
                <p className="text-pry-dark-green-300/80">
                  I understand that reeassigning this role will remove the
                  current assignee and send an invitation to the new email
                  address provided.
                </p>
              }
              className="!items-start text-sm"
            />
          )}
        </div>
      </ModalComponent>
    </>
  );
};
